import * as React from "react";
const SvgFiRrReview = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-review_svg__a)">
      <path
        fill="#062147"
        d="M8 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6M8 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m2 13a1 1 0 0 1-1 1c-3.86 0-7 3.14-7 7a1 1 0 0 1-2 0c0-4.962 4.038-9 9-9a1 1 0 0 1 1 1m13.644 2.752-2.366 1.927.979 2.98a1.002 1.002 0 0 1-1.495 1.152l-2.754-1.793L15.3 23.83a.995.995 0 0 1-1.156-.031 1 1 0 0 1-.354-1.101l.941-3.016-2.377-1.934A.999.999 0 0 1 13 15.986h3.001l1.062-2.98a1.001 1.001 0 0 1 1.874 0l1.062 2.98H23a1 1 0 0 1 .644 1.765z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-review_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrReview;
